import { useAuth } from "@/hooks/use-auth";
import { useLocation } from "wouter";
import { useEffect } from "react";

/**
 * Renders children only if the current user has isAdmin === true.
 * Redirects non-admins to the explore page.
 */
export function AdminGuard({ children }: { children: React.ReactNode }) {
  const { user, isLoading, isAuthenticated } = useAuth();
  const [, navigate] = useLocation();

  const isAdmin = user?.isAdmin === true;

  useEffect(() => {
    if (isLoading) return;
    if (!isAuthenticated || !isAdmin) {
      navigate("/explore", { replace: true });
    }
  }, [isLoading, isAuthenticated, isAdmin, navigate]);

  if (isLoading) return null;
  if (!isAuthenticated || !isAdmin) return null;

  return <>{children}</>;
}
